import Board from './Board';

export * from './types';
export default Board;
